import { render, staticRenderFns } from "./LearningSuitcaseStudentView.vue?vue&type=template&id=589e199a&scoped=true"
import script from "./LearningSuitcaseStudentView.vue?vue&type=script&lang=js"
export * from "./LearningSuitcaseStudentView.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=589e199a&prod&scoped=true&lang=css&external"
import style1 from "./LearningSuitcaseStudentView.vue?vue&type=style&index=1&id=589e199a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589e199a",
  null
  
)

export default component.exports